export default function Error403() {
  return (
    <p>Vous n'avez pas les permissions nécessaires pour accéder à cette ressource.</p>
  )
}
